export const fetchCorporateSubscriberTier = async (axios, email) => {
  const resp = await axios.post("/tier", {
    email,
    withCredentials: true
  });
  return resp.data || "";
};